import { render, staticRenderFns } from "./ExternalDepartmentManage.vue?vue&type=template&id=002b7394&"
import script from "./ExternalDepartmentManage.vue?vue&type=script&lang=js&"
export * from "./ExternalDepartmentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports